module.exports = __webpack_public_path__ + "static/media/redPattern.1490db59.svg";